import { createResource } from 'react-resource-router';
import { UrlHelper } from '../../../common/utils/url-helper';
import { default as ConfiguredIntegrationsAPI } from '../endpoints';
import { CONFIGURED_INTEGRATIONS_RESOURCE_KEY, NAME_KEY, PAGE_KEY, STATUS_KEY, TEAMID_KEY, TYPE_KEY } from './constants';
export const configuredIntegrationsResource = createResource({
  type: 'configuredIntegrationsResource',
  getKey: ({
    query,
    match
  }) => {
    var _match$params$teamId;
    const teamId = (_match$params$teamId = match.params.teamId) !== null && _match$params$teamId !== void 0 ? _match$params$teamId : query['teamId'];
    const group = query['group'];
    const keyword = query['keyword'];
    const status = query['status'];
    const page = query['page'] || '1';
    return UrlHelper(CONFIGURED_INTEGRATIONS_RESOURCE_KEY, {
      [PAGE_KEY]: page,
      [NAME_KEY]: keyword,
      [TYPE_KEY]: group,
      [STATUS_KEY]: status,
      [TEAMID_KEY]: teamId
    });
  },
  getData: routerContext => ConfiguredIntegrationsAPI.getIntegrations(routerContext.query, routerContext.match.params.teamId),
  maxAge: 5 * 60 * 1000,
  // 5 mins
  isBrowserOnly: true
});